// extracted by mini-css-extract-plugin
export var quillEditor = "_mn-1";
export var variable = "_mn-0";